<template>
  <div class="app-container text-left">
    <el-dialog :visible.sync="dialogFormVisible" ref="dlg" width="500px" title="代约详情" :show-close="true"
      :close-on-click-modal="false" v-if="talent!=null && info!=null" :append-to-body="true">
      <router-link target="_blank"
        :to="'/TalentDetail?id='+talent.resumeId+'&type='+talent.resumeType+'&isII='+talent.isInsteadInvite+'&isDL='+talent.isDownload">
        <el-row>
          <el-col :span="2">
            <user-avatar :src="talent.headImage" className="useravatar-cirle-sm"></user-avatar>
          </el-col>
          <el-col :span="22" class="text-left" style="padding-left:10px;">
            <div class="me-name">
              <span>{{ talent.fullName }}</span>
            </div>
            <div class="text-gray">
              {{ talent.expectCity }}·{{ talent.degree }}·{{ talent.workYear }}年工作经验
            </div>
            <div class="text-gray">{{ talent.nearPost }}</div>
          </el-col>
        </el-row>
      </router-link>
      <div class="gray-line"></div>
      <div>服务状态：<el-tag type="success">{{_GetResult()}}</el-tag></div>
      <div v-if="info.interviewTime" style="margin:5px 0;">
        面试时间：<span class="text-gray">{{$Shared.formatDateTime2(info.interviewTime)}}</span>
      </div>
      <div>代约服务顾问：<span class="text-gray">{{info.gwName}}</span>&nbsp;&nbsp;&nbsp;
        <!-- <el-button size="mini" type="text">联系她</el-button> -->
      </div>
      <div>服务时间：<span class="text-gray">{{$Shared.formatDateTime2(info.lastGwServiceTime)}}</span></div>      
      <div>代约备注：<span class="text-gray">{{info.serviceNote}}</span></div>

      <!-- <div><el-button size="mini" type="text">通话录音</el-button></div> -->
      <!-- </el-aside> -->
      <div class="gray-line"></div>
      <!-- <el-main style="margin-top:-20px;"> -->
      <div>代约职位：<span class="text-gray">{{info.postName}}</span></div><br />
      <div>月薪范围：<span class="text-gray">{{info.minSalary}}K - {{info.maxSalary}}K</span></div><br />
      <div>岗位职责:<br />
        <span class="text-gray">{{info.postDescription}}</span>
      </div><br />
      <div>面试地点：<span class="text-gray">{{info.interviewAddress}}</span></div>
      <div>约面要点：<span class="text-gray">{{info.notice}}</span></div>
      <div>面试时间建议：<span class="text-gray">{{info.interviewTimeSuggest}}</span></div>
      <div>发起代约时间：<span class="text-gray">{{info.regDateTime|_ParseTime('{y}-{m}-{d} {h}:{i}')}}</span></div>
      <!-- </el-main> -->
      <!-- </el-aside>
      </el-container>       -->

      <!-- <div class="gray-line"></div> -->

<div slot="footer" class="dialog-footer">
      <!-- <el-row :gutter="10" style="margin-top: 30px;text-align: center;"> -->
        <el-button @click="onCancel">关闭</el-button>
      <!-- </el-row> -->
</div>
    </el-dialog>
  </div>
</template>

<script>
  import userAvatar from '~/components/UserAvatar';
  import {
    parseTime,
    getInsteadInviteState
  } from '~/utils';
  export default {
    components: {
      userAvatar
    },
    data() {
      return {
        dialogFormVisible: false,
        talent: null, //人才信息
        info: null, //代约信息
      };
    },
    filters: {
      _ParseTime(time, cformat) {
        var date = new Date(time);
        return parseTime(date, cformat);
      }
    },
    methods: {
      show(talent, info) {
        this.talent = talent;
        this.info = info;
        this.dialogFormVisible = true;
      },
      //-------------------------------------------------------------------------------
      onCancel() {
        this.dialogFormVisible = false;
      },
      //-------------------------------------------------------------------------------
      _GetResult() {
        let hii = this.info;
        return getInsteadInviteState(hii.isProcessed, hii.isContact, hii.loInterviewId);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .line {
    text-align: center; //color:rgb(185, 93, 60)
  }
</style>